// Learner App does not support translation (see /learnerApp/src/App.tsx)
/* eslint-disable i18next/no-literal-string */
import { Box, Icon, Typography } from "@outschool/backpack";
import { faArrowLeft } from "@outschool/icons";
import { navigate } from "@patched/hookrouter";
import React from "react";

import HeroLayoutWithTabs from "../../layout/HeroLayoutWithTabs/HeroLayoutWithTabs";
import useAnalyticsPage, {
  PageType,
} from "../../lib/analytics/useAnalyticsPage";
import { learnerRoutes } from "../../lib/Routes";
import MixUpMachineContent from "../LearnerPlay/MixUpMachineContent";

export default function MixUpMachine() {
  useAnalyticsPage({ pageName: PageType.Discovery });

  const currentPath = learnerRoutes.playPath();

  return (
    <HeroLayoutWithTabs currentPath={currentPath}>
      <Box sx={{ marginBottom: "1em" }}>
        <Box
          flex
          onClick={() => navigate(learnerRoutes.playPath())}
          sx={{
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            color: "primary.main",
            width: "fit-content",
            "&:hover": { opacity: 0.8 },
          }}
        >
          <Icon icon={faArrowLeft} sx={{ fontSize: "16px" }} />
          <Typography variant="subtitle1">Back to Play</Typography>
        </Box>
      </Box>
      <MixUpMachineContent />
    </HeroLayoutWithTabs>
  );
}
